// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"indicator"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20.9998 17.1113V13.1113H6.78924L4.05859 15.1113L6.78924 17.1113H20.9998Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M3 9V5H17.2105L19.9412 7L17.2105 9H3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9.35303 2V5M9.35303 9V13.1111M14.647 9V13.1111M9.35303 17.1113V22.0002M14.647 17.1113V22.0002M14.647 2V5M3 5V9H17.2105L19.9412 7L17.2105 5H3ZM21 13.1113V17.1113H6.78949L4.05884 15.1113L6.78949 13.1113H21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-indicator')
export default class IndicatorIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'indicator',
    }
  }
}
